import React, { FC, useEffect,useState } from "react";
import ChatWindow from "../organisms/ChatWindow";
import SectionHeader from "../molecules/SectionHeader";
import MainLayout from "../../Layouts/MainLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useChatContext } from "../../../context/ChatContext";
import HistorySidebar from "../organisms/HistorySidebar";
import { ThemeProvider } from "../../../context/ThemeContext"
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import Spinner from "../atoms/Spinner";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
const ChatLayout: FC = () => {
  const { id } = useParams();
  
  const location = useLocation();
  const sidebarType = location.pathname.includes("ai_space") ? "history" : "dashboard";
  const spaceChat = location.pathname.includes("section");
  const { crewName, spaceName } = location.state || location.state.spaceName || { spaceName: "", crewName: "" };
 
  const { fetchChatHistory } = useChatContext();
  const [toggle, setToggle] = useState<boolean>(false);
  const accessCheckLoading = useAccessCheckLoading()
 
  useEffect(() => {
    if (id) fetchChatHistory(id,spaceChat);
  }, [id, fetchChatHistory]);

  const navigate = useNavigate()
  // Navigates to the training page based on whether it's a space chat or crew chat.
const handleTrain = ()=>{
  if(spaceChat){
    navigate(`/training-space/${id}/upload`)
  }
  else {
    navigate(`/training/${id}/upload`)
  }
}

  return (
<>

<ThemeProvider>

      <div className="row m-0 h-100 overflow-auto">
        {toggle && <div className="col-2 p-0 h-100 overflow-auto">
          
          <HistorySidebar Id={id} spaceChat = {spaceChat} toggle={toggle} setToggle={setToggle} /> 
        </div>}
        <div className={`${toggle ? "col-10 px-0" : "col-12 px-0"} h-100 d-flex flex-column overflow-auto`}>
    
        {/* <SectionHeader
            title={
              spaceChat
                ? `Finetune knowledge hub`
                : `Crew AI space`
            }
            action="Build knowledge"
            train = {true}
            onAdd={handleTrain}
          /> */}
      <AccessControl
        requiredPermissions={[
          {
            permission: "manage_space_chat",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
      
       
          <ChatWindow  spaceChat = { spaceChat} Id={id || ""}  toggle={toggle} setToggle={setToggle} />
          </AccessControl>
        </div>
      </div>
    </ThemeProvider>
 
</>
  );
};

export default ChatLayout;
